import React from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../common/api";

import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import { withStyles } from "@material-ui/styles";

const styles = theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  formControl: {
    margin: 10,
    minWidth: 150,
    fontSize: "0.75rem"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
});

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      loading: true,
      errors: false,
      disabled: false,
      password_view: false,
      roles: [],
      user: {
        id: "",
        roles: []
      }
    };
  }
  async componentDidMount() {
    var params = this.getParams();
    var user_id = params.user_id;
    var view = params.view;
    if (user_id !== undefined) {
      await this.getUser(user_id);
      if (view === "0") {
        this.setState({ action: "edit", disabled: false });
      } else {
        this.setState({ disabled: true, action: "view" });
      }
    } else {
      this.setState({ action: "new", disabled: false });
    }
    await this.getRoles();
  }
  getParams() {
    return this.props.match.params;
  }

  getUser(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.users().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var user = res.data[0];
        this.setState({ user: user });
        this.setState({ loading: false });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getRoles() {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.roles().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var roles = res.data;
        roles.map((val, idx) => {
          var role = this.state.user.roles.filter(
            role => parseInt(role.id) === parseInt(val.id)
          );
          if (role.length > 0) {
            val.checked = true;
          }
        });
        this.setState({ roles: roles });
        this.setState({ loading: false });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleRolChange = e => {
    var roles = this.state.roles;
    var element = e.target.name.split(".");
    var key = element[0];
    var id = element[1];
    roles[id]["checked"] = e.target.checked;
    this.setState({ roles: roles });
  };

  handleChange = event => {
    event.preventDefault();
    var key = event.target.name;
    var value = event.target.value;
    var user = this.state.user;
    user[key] = value;
    this.setState({ user: user });
  };

  handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    var formData = new FormData();
    let self = this;
    const token = localStorage.getItem("userToken");
    this.state.roles.map((val, idx) => {
      if (val.checked === true) {
        formData.set("roles[" + idx + "]", val.id);
      }
    });
    formData.set("user_id", this.state.user.id);
    formData.set("name", this.state.user.name);
    formData.set("email", this.state.user.email);
    formData.set("hansa_id", this.state.user.hansa_id);
    formData.set("freshdesk_user_id", this.state.user.freshdesk_user_id);

    if (this.state.action === "new") {
      formData.set("password", this.state.user.password);
      axios
        .post(api.users().post(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false, save_user: true });
          self.setState({ message: "Usuario creado con éxito!" });
          self.setState({ dialogOpen: true });
        })
        .catch(function(error) {
          self.setState({ errors: true, save_user: false });
          var message = "";
          var promise = new Promise(function(resolve, reject) {
            resolve(error);
            if (error.response.data.errors.email) {
              message += error.response.data.errors.email;
            }
            if (error.response.data.errors.password) {
              message += error.response.data.errors.password;
            }
            if (message === "") {
              message =
                "Hubo un problema al guardar el usuario. Por favor volver a intentar";
            }
          });

          self.setState({ message: message });
          self.setState({ dialogOpen: true });
        });
    } else {
      formData.append("_method", "patch");
      axios
        .post(api.users().patch(this.state.user.id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false, save_user: true });
          self.setState({ message: "Usuario modificado con éxito!" });
          self.setState({ dialogOpen: true });
        })
        .catch(function(error) {
          var message = "";
          var promise = new Promise(function(resolve, reject) {
            resolve(error);
            if (error.response.data.errors) {
              error.response.data.errors.map((val, idx) => {
                message += val;
              });
            } else {
              message =
                "Hubo un problema al guardar el usuario. Por favor volver a intentar";
            }
          });

          self.setState({ message: message });
          self.setState({ errors: true, save_user: false });
          self.setState({
            message:
              "Hubo un problema al guardar el usuario. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
        });
    }
  };

  handlePasswordView = () => {
    var password_view = this.state.password_view;
    this.setState({ password_view: !password_view });
  };

  render() {
    const handleRedirect = () => {
      window.location.href = `/users`;
    };

    const handleDialogClose = () => {
      this.setState({ dialogOpen: false });
    };
    const { classes } = this.props;
    const disabled = this.state.disabled;
    const { user } = this.state;
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle sm="4" title={"Usuario"} className="text-sm-left" />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Usuario"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.save_user ? (
                      <Button
                        onClick={handleRedirect}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.errors ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="row ml-1">
                      <TextField
                        id="name"
                        name="name"
                        label="Nombre"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el nombre"
                        onChange={this.handleChange}
                        value={user.name}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="email"
                        name="email"
                        label="Email"
                        disabled={disabled}
                        type="email"
                        required
                        placeholder="Ingrese el email"
                        onChange={this.handleChange}
                        value={user.email}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="hansa_id"
                        name="hansa_id"
                        label="ID Hansa"
                        disabled={disabled}
                        type="text"
                        placeholder="Ingrese el id de hansa"
                        onChange={this.handleChange}
                        value={user.hansa_id}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="freshdesk_user_id"
                        name="freshdesk_user_id"
                        label="ID Freshdesk"
                        disabled={disabled}
                        type="text"
                        placeholder="Ingrese el ID de freshdesk"
                        onChange={this.handleChange}
                        value={user.freshdesk_user_id}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />

                      {this.state.action === "new" ? (
                        <TextField
                          id="password"
                          name="password"
                          label="Contraseña"
                          disabled={disabled}
                          type={this.state.password_view ? "text" : "password"}
                          required
                          placeholder="Ingrese la contraseña"
                          onChange={this.handleChange}
                          value={user.password}
                          margin="normal"
                          className="mr-2 "
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            style: { minWidth: 200, fontSize: "0.75rem" }
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {this.state.password_view ? (
                                  <VisibilityOffIcon
                                    onClick={this.handlePasswordView}
                                  />
                                ) : (
                                  <VisibilityIcon
                                    onClick={this.handlePasswordView}
                                  />
                                )}
                              </InputAdornment>
                            )
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      {this.state.roles.map((val, idx) => {
                        return (
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  id={"role_id." + idx}
                                  value={val.checked}
                                  checked={val.checked}
                                  name={"role_id." + idx}
                                  disabled={this.state.disabled}
                                  label={val.name}
                                  onChange={this.handleRolChange}
                                  size="small"
                                  color="primary"
                                  className="ml-2 mr-4"
                                  inputProps={{
                                    "aria-label": "primary checkbox"
                                  }}
                                />
                              }
                              label={val.name}
                              labelPlacement="start"
                            />
                          </div>
                        );
                      })}
                    </div>

                    {this.state.action !== "view" ? (
                      <React.Fragment>
                        <Button
                          type="submit"
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="primary"
                        >
                          Guardar
                        </Button>
                        <Button
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="secondary"
                          href={"/users"}
                        >
                          Cancelar
                        </Button>
                      </React.Fragment>
                    ) : (
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="secondary"
                        href={"/users"}
                      >
                        Volver
                      </Button>
                    )}
                  </form>
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withStyles(styles)(User);
